export const bonuses = [
  {
    number: 1,
    title: "The Facial Aesthetic Clinical Casebook",
    subtitle: "Educational Scenarios for Structured Clinical Review",
    intro: [
      "Explore hypothetical facial aesthetic cases organized around patient information, observed findings, assessment considerations, and questions for professional discussion.",
      "Rather than reviewing isolated facts, you’ll have an organized format for examining different presentations and considering what additional information may be relevant.",
    ],
    inside: [
      "Hypothetical case presentation sheets",
      "Patient history summaries",
      "Clinical observation worksheets",
      "Structured discussion questions",
      "Educational review notes",
      "Case analysis templates",
    ],
    note: "",
    value: "$19",
    image: "https://cdn.magicpatterns.com/uploads/cMCY1BbXHAQ1tNzbvjsNrU/BONUS_1_FACIAL-EN.png",
  },
  {
    number: 2,
    title: "The Pre-Procedure Assessment Toolkit",
    subtitle: "Organize Your Patient Assessment Documentation",
    intro: [
      "This practical toolkit brings together educational forms and worksheets designed to help organize relevant patient information before a procedure.",
    ],
    inside: [
      "Patient assessment worksheet",
      "Medical history review form",
      "Pre-procedure documentation checklist",
      "Treatment planning considerations worksheet",
      "Patient information review sheet",
    ],
    note: "Adapt the materials to your scope of practice and applicable professional requirements.",
    value: "$17",
    image: "https://cdn.magicpatterns.com/uploads/v7BBk1DrQskez2XtFqdFoa/BONUS_2_FACIAL-EN.png",
  },
  {
    number: 3,
    title: "The Facial Aesthetic Warning Signs Atlas",
    subtitle: "A Visual Reference for Studying Potentially Concerning Presentations",
    intro: [
      "This educational resource organizes selected warning signs into a visual reference format that supports professional study.",
    ],
    inside: [
      "Visual learning tables",
      "Warning-sign reference cards",
      "Clinical observation worksheets",
      "Symptom documentation templates",
      "Urgency and escalation considerations",
      "Educational presentation comparisons",
    ],
    note: "This atlas is an educational reference and does not replace emergency assessment or current clinical protocols.",
    value: "$19",
    image: "https://cdn.magicpatterns.com/uploads/fS6GACsRpvdcCQ5MFhrq4A/BONUS_3_FACIAL-EN.png",
  },
  {
    number: 4,
    title: "The Patient Follow-Up Documentation Toolkit",
    subtitle: "Organize Follow-Up Records and Clinical Communications",
    intro: [
      "Bring relevant documentation resources together in one place with templates designed for recording patient progress and organizing follow-up information.",
    ],
    inside: [
      "Follow-up record templates",
      "Patient communication documentation examples",
      "Treatment review forms",
      "Adverse-event documentation worksheets",
      "Referral and escalation record templates",
      "Follow-up review checklists",
    ],
    note: "All patient-facing materials should be reviewed and adapted to applicable local requirements.",
    value: "$17",
    image: "https://cdn.magicpatterns.com/uploads/5BBgpGn97UYjpYMxPVhhBu/BONUS_4_FACIAL-EN.png",
  },
  {
    number: 5,
    title: "The Clinical Safety Audit Workbook",
    subtitle: "Review the Organization of Your Clinical Safety Resources",
    intro: [
      "This workbook provides a structured format for reviewing documentation practices, emergency preparedness, available resources, and follow-up processes within a professional setting.",
    ],
    inside: [
      "Practice readiness checklist",
      "Equipment and resource review sheets",
      "Documentation quality checklist",
      "Emergency preparedness review",
      "Follow-up process audit",
      "Improvement planning worksheets",
    ],
    note: "The workbook supports internal review. It does not certify compliance or replace applicable professional standards.",
    value: "$19",
    image: "https://cdn.magicpatterns.com/uploads/1VjCku8AL9SAxpEsZ6ndA9/BONUS_5_FACIAL-EN.png",
  },
];
